<template>
  <div class="login container">

    <form @submit.prevent="submit" class="d-flex align-items-center flex-column">
 
        <div class="row">
         <h2 class="col-md-12 pt-5">Switch Sites</h2>
         </div>

        <div class="row" v-if="loading">
          <div class="col-12 pt-2">
            <div class="loader" ></div>
          </div>
        </div>

          <div v-if="!loading">
            <div class="select-holder">
              
          <div class="row">
              <label class="col-md-12 pt-3">Brand</label>
          </div>
          <div class="row pl-2 pr-2">
              <select v-model="stored_account">
                <option :value="false">Select Brand</option>
                <option v-for="a in accounts" :value="a" v-bind:key="a.id">
                  {{a.name}}
                </option>
              </select>
            </div>
          </div>
        </div>
        
          <div v-if="!loading && stored_account">
            <div class="select-holder">

              <div class="row">
                <p class="col-md-12 pt-4">Site</p>
              </div>

              <div class="row pl-2 pr-2">
              <select v-model="stored_unit" >
                <option :value="false">Select Site</option>
                <option v-for="u in stored_account.Units" :value="u" v-bind:key="u.id">
                  {{u.name}}
                </option>
              </select>
              </div>
            </div>
          </div>  
    </form>
   
  </div>
  
</template>

<script>
export default {
  name: 'Site',
  inject: ['$validator'],
  data : function(){       
      return {
        submitted     : false,
        loading       :true
      };
  },
  created:function(){
    this.getAccount();
  },

  computed:{

    stored_account:
    {
      get: function (){
        return this.$store.getters.getAccount;
      },

      set: function (value){
        this.$store.commit('SET_ACCOUNT', value);
      }
    },

    stored_unit:
    {
      get: function (){
        return this.$store.getters.getUnit;
      },

      set: function (value){
        this.$store.commit('SET_UNIT', value);
      }
    },

    accounts()
    {
      return this.$store.getters.getAccounts;
    }

  },

  watch:{

    stored_account: function(newVal, oldVal){

      if(!newVal){
        return;
      }

      if((!oldVal || (newVal.id != oldVal.id)) && newVal && this.stored_account && this.stored_account.Units && this.stored_account.Units.length){
          this.stored_unit = this.stored_account.Units[0];
      }

      if(!this.stored_account.Units.length){
          this.$bus.$emit('error_message', 'Account has no units assigned.');
          this.stored_account = false;
      }

    },

  },
  methods:{



      /*
      * Login form submit handler
      */
      getAccount()
      {

        this.loading = true;
        this.$store.dispatch('updateConfig')
        .then()
        .catch( (error) => {
            this.$bus.$emit('error_message', error);
        }).then(() => {
            this.loading = false;
        });
          
      },

  }
}
</script>

<style scoped>

</style>
